import { FileModel as Model } from './Model'


export const MODULE_NAME = 'files'

export const FILES_ROUTES = {
  LAYOUT: MODULE_NAME,
  LIST: `${MODULE_NAME}.list`,
  VIEW: `${MODULE_NAME}.view`,
  EDIT: `${MODULE_NAME}.edit`,
  CREATE: `${MODULE_NAME}.create`,
} as const

export const MENU = {
  id: FILES_ROUTES.LAYOUT,
  route: { name: FILES_ROUTES.LAYOUT },
  label: Model.page_title.list,
  icon: 'mdi-file-document-multiple-outline',
} as const
